import React from "react";
import { Icon, Label, Popup } from "semantic-ui-react";

interface IStaffOnlyLabel {
  popupPosition?:
    | "left center"
    | "top left"
    | "top right"
    | "bottom right"
    | "bottom left"
    | "right center"
    | "top center"
    | "bottom center"
    | undefined;
  popupContent?: string;
  labelText?: string;
  labelStyle?: Record<string, any>;
}

const DefaultStaffOnlyProps: IStaffOnlyLabel = {
  popupPosition: "top right",
  popupContent: "This permit type is only visible to staff",
  labelText: "Staff Only",
} as const;

const StaffOnlyLabel = (props: IStaffOnlyLabel) => {
  const { labelText: buttonText, popupPosition, popupContent } = { ...DefaultStaffOnlyProps, ...props };

  const trigger = (
    <Label
      style={{
        borderRadius: "20px",
        float: "right",
        backgroundColor: "gray",
        color: "white",
        ...props.labelStyle,
        marginBottom: "10px",
      }}
    >
      <Icon name={"eye"}></Icon>
      {buttonText}
    </Label>
  );
  return <Popup position={popupPosition} content={popupContent} trigger={trigger} />;
};

export default StaffOnlyLabel;
